import CheckIcon from "assets/icons/Check";

export const slotGamesDevelopmentCompanyTextContent = {
  headingText: "GammaStack: Your Best Online Slot Games Development Company",
  paraText: (
    <>
      <strong>GammaStack</strong> is a one-stop shop for all your slot game needs. Whether you are looking for custom slot games or ready-to-launch slot games, we’ve got you covered for both. Explore our rich portfolio or get your very own slot game designed and developed. In our 8+ years of experience, we have enabled several casino slots to accelerate their success and now, you can also leverage our slot game development services to turbo-charge your business.
    </>
  ),
  imgSrc: "/assets/stock-img/slot_game_development_company_img.webp",
  content: [
    {
      chipIconSrc: <CheckIcon />,
      chipLabelText: "Fully Unique Slot Games",
    },
    {
      chipIconSrc: <CheckIcon />,
      chipLabelText: "Superb Themes & Animations",
    },
    {
      chipIconSrc: <CheckIcon />,
      chipLabelText: "Quick Market Entry",
    },
  ],
};
